// age-verification.component.ts

import { Component, OnInit, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { EventsService } from 'src/app/services/event/event.service';
import { GameHubControllerService } from 'src/app/services/gameHub/game-hub-controller';

@Component({
  selector: 'app-age-verification',
  templateUrl: './age-verification.component.html',
  styleUrls: ['./age-verification.component.scss'],
})
export class AgeVerificationComponent implements OnInit {
  @Input() gameData: any;

  constructor(
    private modalCtrl: ModalController,
    private gameHubControllerService: GameHubControllerService
  ) {}

  ngOnInit() {}

  confirm() {
    this.gameHubControllerService.launchCasinoGameDemo(this.gameData);
    this.close();
  }

  decline() {
    this.close();
  }

  close() {
    this.modalCtrl.dismiss();
  }
}
